import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ToolsService} from '../../services/tools/tools.service';
import {HydraService} from '../../../core/services/hydra.service';


@Component({
    selector: 'app-file-downloader',
    templateUrl: './file-downloader.component.html',
    styleUrls: ['./file-downloader.component.scss'],
    imports: []
})
export class FileDownloaderComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private toolsService = inject(ToolsService);
    private hydraService = inject(HydraService);


    public downloading = true;


    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params.fileId) {
                this.download(params.fileId);
            }
        });
    }

    public download(fileId) {
        this.downloading = true;
        this.hydraService.getItem('/api/fichiers/' + fileId).subscribe(res => {
            this.toolsService.download(res).then(() => {
                this.downloading = false;

                setTimeout(
                    () => {
                        window.close();
                    },
                    1000
                );
            });
        });
    }

}
